import {
  Box,
  Flex,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Text,
} from "@chakra-ui/react";
import { BiCalendarHeart, BiSolidMap, BiEnvelopeOpen } from "react-icons/bi";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import moment from "moment";
import RSVPBG from "../../../src/assets/RSVPBG.jpg";
import RSVPBG3 from "../../../src/assets/RSVPBG4.jpg";
import QrCode from "qrcode.react";
import { BASE_URL_EVENT, BASE_URL_MEDIA } from "../../Redux/App/action";

const AcceptInvitation = () => {
  const accessToken = localStorage.getItem("token");
  const [data, setData] = useState({});
  const [venue, setVenue] = useState([]);
  const [getvenue, setGetVenue] = useState({});
  const [rsvpconfirm, setRsvpConfirm] = useState("");
  const [accommodation, setAccommodation] = useState(false);
  const [flight, setFlight] = useState(false);
  const param = useParams();
  const id = param._id;

  const [timeRemaining, setTimeRemaining] = useState("");

  const getDetails = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_EVENT}/rspvdetails/get?invitationId=${id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        setData(response.data.payload);
        setGetVenue(response.data.payload.venueImg);
        setAccommodation(response.data.payload.accommodationFlag);
        setFlight(response.data.payload.flightFlag);

        const eventDate = moment(response.data.payload.eventTiming);
        const currentTime = moment();
        const duration = moment.duration(eventDate.diff(currentTime));

        const intervalId = setInterval(() => {
          const newDuration = moment.duration(eventDate.diff(moment()));

          const days = String(newDuration.days()).padStart(2, "0");
          const hours = String(newDuration.hours()).padStart(2, "0");
          const minutes = String(newDuration.minutes()).padStart(2, "0");
          const seconds = String(newDuration.seconds()).padStart(2, "0");

          const formattedTime = `${days} : ${hours} : ${minutes} : ${seconds}`;

          setTimeRemaining(formattedTime);

          if (newDuration.asMilliseconds() <= 0) {
            clearInterval(intervalId);
            setTimeRemaining("Event has started");
          }
        }, 1000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  const handleAcceptClick = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL_EVENT}/rsvpdetails/update?invitationId=${id}`,
        {
          rsvpStatus: rsvpconfirm,
          shagunGiving: false,
          onlySpecialNote: false,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`, // Add your authentication token here
          },
        },
      );

      if (response.status === 200) {
        // Handle success, e.g., display a success message or update the UI
        console.log("RSVP Accepted successfully");
      } else {
        // Handle other status codes or errors
        console.error("Failed to update RSVP");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const getVenueImage = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_MEDIA}/media/file/admin/get/productfiles?sourceMediaId=534`,
        {
          headers: {
            Accept: "application/json",
          },
        },
      );
      if (response.status === 200) {
        setVenue(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getVenueImage();
  }, []);

  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const countdownStyle = {
    fontSize: "24px",
    fontWeight: "semibold",
    color: "#333",
    backgroundColor: "#f5f5f5",
    padding: "10px 20px",
    borderRadius: "5px",
    display: "inline-block",
  };
  return (
    <Box
      bgImage={RSVPBG3}
      bgSize="cover"
      bgRepeat="no-repeat"
      bgPosition="center"
      minHeight="100vh"
    >
      <Flex flexDir={{ base: "column", md: "column" }}>
        {/* Greeting Preview */}
        <Box
          backgroundImage={RSVPBG}
          backgroundSize="cover"
          backgroundRepeat="no-repeat"
          backgroundPosition="center center"
          mt={10}
          w={{ base: "80%", md: "40%" }}
          h="40%"
          boxShadow="2px 5px 10px #00000029"
          borderWidth="1px"
          borderColor="#707070"
          opacity={1}
          borderRadius="10px"
          mx="auto"
          p={"4"}
        >
          <Box
            color={"#3C375F"}
            fontStyle={"Sans-serif"}
            fontFamily={"popins"}
            fontSize={{ base: "20", md: "36px", lg: "36px" }}
            fontWeight={"semiBold"}
            textAlign={"center"}
          >
            {" "}
            RSVP
          </Box>
          <Box h={"80%"}>
            <Image
              p={"4"}
              mt={"10"}
              margin={"auto"}
              height={{ base: "100%", md: "50%" }}
              w={{ base: "100%", md: "50%" }}
              src={data.previewImgUrl}
            />
          </Box>

          <Box>
            <Text
              color={"black"}
              fontStyle={"Sans-serif"}
              fontFamily={"popins"}
              fontSize={{ base: "12", md: "18", lg: "18" }}
              fontWeight={"semiBold"}
              textAlign={"center"}
            >
              Are You Joining Us?
            </Text>
            <Box w={"40%"} margin={"auto"}>
              <Flex
                gap={"4"}
                justifyContent={"space-between"}
                flexDir={{ base: "column", md: "row" }}
              >
                <Button
                  fontSize="14"
                  size={{ base: "xs", md: "sm" }}
                  w={{ base: "100%", md: "40%" }}
                  onClick={() => {
                    setRsvpConfirm("ACCEPTED");
                    handleAcceptClick();
                  }}
                  mt={"4"}
                >
                  Accept
                </Button>
                <Button
                  fontSize="14"
                  size={{ base: "xs", md: "sm" }}
                  w={{ base: "100%", md: "40%" }}
                  onClick={() => {
                    setRsvpConfirm("REJECTED");
                    handleAcceptClick();
                  }}
                  mt={"4"}
                >
                  Decline
                </Button>
                <Button
                  fontSize="14"
                  size={{ base: "xs", md: "sm" }}
                  w={{ base: "100%", md: "40%" }}
                  onClick={() => {
                    setRsvpConfirm("MAYBE");
                    handleAcceptClick();
                  }}
                  mt={"4"}
                >
                  Maybe
                </Button>
              </Flex>
            </Box>
          </Box>
        </Box>
        <Box w={"100%"}>
          <Box
            color={"white"}
            fontStyle={"Sans-serif"}
            fontFamily={"popins"}
            fontSize={{ base: "12", md: "18", lg: "18" }}
            fontWeight={"semiBold"}
            textAlign={"center"}
            mt={"10"}
          >
            {" "}
            Time Remaining Until Event:
          </Box>
          <Text fontSize="18" mt="2" textAlign="center">
            <span style={countdownStyle}>{timeRemaining}</span>
          </Text>
          <Box
            margin={"auto"}
            w={"14%"}
            display={"flex"}
            flexDir={"row"}
            justifyContent={"space-evenly"}
          >
            <Text color={"white"} fontSize="8" mt="2" textAlign="center">
              Days
            </Text>
            <Text color={"white"} fontSize="8" mt="2" textAlign="center">
              Hours
            </Text>
            <Text fontSize="8" color={"white"} mt="2" textAlign="center">
              Minutes
            </Text>
            <Text color={"white"} fontSize="8" mt="2" textAlign="center">
              Seconds
            </Text>
          </Box>
        </Box>

        {/* Other Details */}
        <Box mt={"5"}>
          <Box
            color={"white"}
            fontStyle={"Sans-serif"}
            fontFamily={"popins"}
            fontSize={{ base: "12", md: "18", lg: "18" }}
            fontWeight={"semiBold"}
            textAlign={"center"}
            mt={"10"}
            margin={"auto"}
          >
            {" "}
            We Can't Wait To Celebrate With You!
          </Box>

          <Box margin={"auto"} w={{ base: "100%", md: "50%" }} height={"100%"}>
            <Box w={"100%"} margin={"auto"}>
              <Flex
                justifyContent={"space-evenly"}
                flexDir={{ base: "row-reverse", md: "row" }}
              >
                <Box p={"4"} w={"100%"} h={"100%"} mt={"5"} borderRadius={"10"}>
                  <Flex flexDir={"column"}>
                    <Box display={"flex"}>
                      <BiSolidMap color={"white"} size={20} />
                      <Text
                        color={"white"}
                        fontStyle={"Sans-serif"}
                        fontSize={{ base: "14", md: "14", lg: "14" }}
                        fontWeight={"semibold"}
                        textAlign={"left"}
                        mb={"5"}
                      >
                        Venue Details:
                      </Text>
                    </Box>
                    <Box textColor={"white"} textAlign={"left"}>
                      <Text fontFamily={"oswald sans-serif"} fontSize={"12px"}>
                        Venue: {data.venue}
                      </Text>
                      <Text fontFamily={"oswald sans-serif"} fontSize={"12px"}>
                        Pincode - {data.venuePincode}
                      </Text>
                      <Text fontFamily={"oswald sans-serif"} fontSize={"12px"}>
                        {accommodation && <p>Accommodation: Yes</p>}
                        {flight && <p>Flight: Yes</p>}
                      </Text>
                    </Box>
                  </Flex>
                </Box>
                <Box p={"4"} w={"100%"} h={"100%"} mt={"5"} borderRadius={"10"}>
                  <Flex flexDir={"column"}>
                    <Box display={"flex"}>
                      <BiCalendarHeart color={"white"} size={20} />
                      <Text
                        color={"white"}
                        fontStyle={"Sans-serif"}
                        fontSize={{ base: "14", md: "14", lg: "14" }}
                        fontWeight={"semibold"}
                        textAlign={"left"}
                        mb={"5"}
                      >
                        Event Details:
                      </Text>
                    </Box>
                    <Box textAlign={"left"}>
                      <Text
                        color={"white"}
                        fontFamily={"oswald sans-serif"}
                        fontSize={"12px"}
                      >
                        Event Name: {data.eventName}
                      </Text>

                      <Text
                        color={"white"}
                        fontFamily={"oswald sans-serif"}
                        fontSize={"12px"}
                      >
                        Event Type: {data.eventType}
                      </Text>

                      <Text
                        fontFamily={"oswald sans-serif"}
                        color={"white"}
                        fontSize={"12px"}
                      >
                        Expected Guests: {data.expectedNoOfGuests}
                      </Text>
                      <Text
                        fontFamily={"oswald sans-serif"}
                        fontSize={"12px"}
                        color={"white"}
                      >
                        Event Details: {data.eventDetails}
                      </Text>
                    </Box>
                  </Flex>
                </Box>
                <Box w="100%" p="4" h="100%" mt="5" borderRadius="10">
                  <Flex flexDir={"column"}>
                    <Box display={"flex"} flexDir={"column"} margin={"auto"}>
                      <Button
                        color={"#3C375F"}
                        fontStyle={"Sans-serif"}
                        fontSize={{ base: "8", md: "14", lg: "14" }}
                        fontWeight={"semibold"}
                        textAlign={"center"}
                        onClick={openModal}
                      >
                        {" "}
                        <BiEnvelopeOpen size={20} />
                        Give eShagun
                      </Button>
                    </Box>
                  </Flex>
                </Box>
              </Flex>
            </Box>
          </Box>
        </Box>
      </Flex>

      {/* Modal */}
      <Modal isOpen={showModal} onClose={closeModal} size="md">
        <ModalOverlay />
        <ModalContent margin={"auto"}>
          <ModalHeader margin={"auto"}>Give e-Shagun</ModalHeader>
          <ModalCloseButton />
          <ModalBody margin={"auto"}>
            <QrCode
              value={`upi://pay?pa=${data.upiId}&pn=aman&am=10&tn=wishfy`}
              size={128}
            />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" margin={"auto"}>
              UPI ID: {data.upiId}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Special Notes */}
      <Box w={"100%"} mt={"20"}>
        <Box
          color={"white"}
          fontStyle={"Sans-serif"}
          fontSize={{ base: "12", md: "18", lg: "18" }}
          fontWeight={"Bold"}
          textAlign={"center"}
          ml={"5"}
        >
          {" "}
          Give A Special Note
        </Box>
        <Input
          color={"white"}
          as={"textarea"}
          width={"50%"}
          height={"20vh"}
          mb={"10"}
        ></Input>
      </Box>

      {/* Rest of your component code */}
    </Box>
  );
};

export default AcceptInvitation;
